export default __webpack_public_path__ + "static/media/ic-categories.e2eecce3.svg";